import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo, useCallback, useState } from "react";
import { DefaultForm } from "../../components";
import { ManualScoringModel, ScoreType } from "../../entities/scoring";
import { useGetUsersQuery } from "../../features/identity/identityApi";
import { UserModel } from "../../entities/user";
import { useManualScoringMutation } from "../../features/identity/scoringApi";
import { Alert, message } from "antd";

export const ManualScoring = memo(() => {
  let model: ManualScoringModel = {
    userIds: [],
    scoreType: ScoreType.Registration,
  };

  const [manualScoring, manualScoringStatus] = useManualScoringMutation();
  const [sumManualScores, setSumManualScores] = useState<number>();

  const onFinish = useCallback(
    async (model: ManualScoringModel) => {
      message.loading({ content: "در حال انجام عملیات", key: "ManualScoring", duration: 0 });
      try {
        setSumManualScores(undefined);
        var sumScores = await manualScoring(model).unwrap();
        setSumManualScores(sumScores);
        message.success({
          content: "عملیات با موفقیت انجام شد",
          key: "ManualScoring",
          duration: 5,
        });
      } catch (error: any) {
        message.error({
          content: "عملیات با خطا مواجه شد",
          key: "ManualScoring",
          duration: 5,
        });
        if (error.status === 403) {
          message.error({
            content: "شما مجوز لازم برای انجام این عملیات را ندارید",
            key: "ManualScoring",
            duration: 5,
          });
        }
      }
    },
    [manualScoring]
  );

  return (
    <div className="max-w-screen-sm">
      <DefaultForm onFinish={onFinish} layout="vertical" initialValues={model}>
        <DefaultForm.DataSelect
          name="userIds"
          label="کاربر(ها)"
          placeholder="انتخاب کاربر(ها)"
          multiple={true}
          query={useGetUsersQuery}
          displayText={(x: UserModel) => `${x.userName} (${x.realName || x.phoneNumber || x.email})`}
          loadAll={true}
          filterPredicate={(record: UserModel, filterText: string) =>
            record.userName.includes(filterText) || record.phoneNumber.includes(filterText) || (record.realName?.includes(filterText) ?? false)
          }
        />

        <DefaultForm.EnumSelect name="scoreType" type={ScoreType} />

        <DefaultForm.SubmitButton loading={manualScoringStatus.isLoading} icon={<FontAwesomeIcon className="anticon" icon={faPlusCircle} />}>
          امتیازدهی
        </DefaultForm.SubmitButton>
        {sumManualScores !== undefined && <Alert type="success" message={`مجموع امتیازات ثبت شده: ${sumManualScores}`} showIcon={true} />}
      </DefaultForm>
    </div>
  );
});
